export default function sanitize($sce) {
	return function(htmlCode) {
		return $sce.trustAsHtml(htmlCode);
	}
};